import Types from '../Types';

const attemptFindPayments = (payload) => ({
  type: Types.FIND_PAYMENTS_ATTEMPT,
  payload: payload
});

const attemptFindAllPayments = (payload) => ({
  type: Types.FIND_ALL_PAYMENTS_ATTEMPT,
  payload: payload
});

const attemptSavePayment = (payload) => ({
  type: Types.SAVE_PAYMENT_ATTEMPT,
  payload: payload
})

export default {
  attemptFindPayments,
  attemptFindAllPayments,
  attemptSavePayment
};



/** WEBPACK FOOTER **
 ** ./src/redux/payment/paymentActions.js
 **/